import { render, staticRenderFns } from "./profileBuIujp.vue?vue&type=template&id=2c9218dc&scoped=true&"
import script from "./profileBuIujp.vue?vue&type=script&lang=js&"
export * from "./profileBuIujp.vue?vue&type=script&lang=js&"
import style0 from "./profileBuIujp.vue?vue&type=style&index=0&id=2c9218dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9218dc",
  null
  
)

export default component.exports